export const FIREBASE_DOCS = {
  APP_STATUS: 'app_status'
};
